// Focus helpers shared by the layout and the global search.

// Focus can only go back to an element still in the document and rendered: no display:none or
// visibility:hidden on it or an ancestor (e.g. the desktop sidebar below `md`, the menu button from `md`).
export function isShown(element) {
  if (!element?.isConnected || typeof window === "undefined") return false;
  for (let node = element; node; node = node.parentElement) {
    const style = window.getComputedStyle(node);
    if (style.display === "none" || style.visibility === "hidden") return false;
  }
  return true;
}

// Focus an element and report whether it actually received focus.
export function focusIfShown(element) {
  if (!isShown(element)) return false;
  element.focus();
  return document.activeElement === element;
}

// Focus an element that is not normally focusable (the page content) without adding it to the tab order.
export function focusTemporarily(element) {
  if (!element) return;
  element.setAttribute("tabindex", "-1");
  element.addEventListener("blur", () => element.removeAttribute("tabindex"), { once: true });
  element.focus();
}
